import axios from 'axios';
import { DEFAULT_TIME_ZONE } from '@/helpers/timeZoneOptions';

export const state = () => ({});

export const getters = {};

export const mutations = {};

export const actions = {
    index() {
        return axios.$get('/v1/admin/business_profiles');
    },

    store(vuexContext, data) {
        const { name, logo, profieleIdToCopy, timeZone } = data;
        const formData = new FormData();

        formData.append('name', name);
        formData.append('time_zone', timeZone || DEFAULT_TIME_ZONE);

        if (logo) {
            formData.append('logo', logo);
        }

        if (profieleIdToCopy) {
            formData.append('copied_business_profile_id', profieleIdToCopy);
        }

        return axios.$post('/v1/admin/business_profiles', formData);
    },

    update(vuexContext, data) {
        const { id, name, logo, profieleIdToCopy, timeZone } = data;
        const formData = new FormData();

        formData.append('name', name);
        formData.append('time_zone', timeZone || DEFAULT_TIME_ZONE);

        if (logo && typeof logo !== 'string') {
            formData.append('logo', logo);
        }

        if (profieleIdToCopy) {
            formData.append('copied_business_profile_id', profieleIdToCopy);
        }

        return axios.$patch(`/v1/admin/business_profiles/${id}`, formData);
    }
};
